import React from "react"
import s from "./TagFilterWrapper.module.scss"
import imgTags from "./assets/tags.svg"
import { Holder } from "components/holder/Holder"
import { TagFilter } from "components/mantra/tag-filter/TagFilter"

export const TagFilterWrapper = (props) => (
  <div className={s.wrapper}>
    <Holder>
      <div className={s.content}>
        <div className={s.label}>
          <img src={imgTags} alt="Topics" />
          Topics
        </div>
        <TagFilter
          activeTags={props.activeTags}
          toggleActiveTag={props.toggleActiveTag}
        />
      </div>
    </Holder>
  </div>
)
